import Vue from 'vue'
import Router from 'vue-router'
import { Message } from 'element-ui'
 
Vue.use(Router)

/**
 * 重写路由的push方法
 */
 const routerPush = Router.prototype.push
 Router.prototype.push = function push(location) {
   return routerPush.call(this, location).catch(error=> error)
 }

const routes = [
    {
        name: '登录',
        path: '/login',
        component: resolve => require(['@/pages/login/login'], resolve)
    },
    {
        name: '404',
        path: '/404',
        component: resolve => require(['@/pages/404/404'], resolve)
    },
    //首页
    {
        path: '/',
        component: resolve => require(['@/components/index/index'], resolve),
        children: [
            {
                name: '首页',
                path: '/',
                component: resolve => require(['@/pages/index/index'], resolve),
                meta:{
                    requireAuth: true
                },
            },
        ]
    },

    //订单贷后处置
    {
        path: '/',
        name: '订单贷后处置',
        component: resolve => require(['@/components/index/index'], resolve),
        children: [
            {
                name: '交易保列表',
                path: '/JybList',
                component: resolve => require(['@/pages/orderDisposal/Jyb'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '提放保列表',
                path: '/TfbList',
                component: resolve => require(['@/pages/orderDisposal/Tfb'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '商转公列表',
                path: '/BusinessList',
                component: resolve => require(['@/pages/orderDisposal/Business'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '订单贷后处置详情',
                path: '/Detail',
                component: resolve => require(['@/pages/orderDisposal/Detail'], resolve),
                meta:{
                    requireAuth: true
                },
            },
        ]
    },

    //订单业务
    {
        path: '/',
        name: '我的订单',
        component: resolve => require(['@/components/index/index'], resolve),
        children: [
            {
                name: '交易保订单',
                path: '/DealForm',
                component: resolve => require(['@/pages/myOrder/orderForm/DealForm'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '交易保创建订单',
                path: '/addOrder',
                component: resolve => require(['@/pages/myOrder/orderForm/addOrder'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '交易保订单详情',
                path: '/orderDetail',
                component: resolve => require(['@/pages/myOrder/orderForm/orderDetail'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '提放保订单',
                path: '/DrawForm',
                component: resolve => require(['@/pages/myOrder/insureOrder/drawForm'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '提放保创建订单',
                path: '/insureAddOrder',
                component: resolve => require(['@/pages/myOrder/insureOrder/insureAddOrder'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '提放保订单详情',
                path: '/insureOrderDetail',
                component: resolve => require(['@/pages/myOrder/insureOrder/insureOrderDetail'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '商转公订单',
                path: '/BusinessForm',
                component: resolve => require(['@/pages/myOrder/BtoB/BusinessForm'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '商转公创建订单',
                path: '/addBusiness',
                component: resolve => require(['@/pages/myOrder/BtoB/addBusiness'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '商转公订单详情',
                path: '/detailBusiness',
                component: resolve => require(['@/pages/myOrder/BtoB/detailBusiness'], resolve),
                meta:{
                    requireAuth: true
                },
            },
        ]
    },

    //团队订单查询
    {
        path: '/',
        name: '团队订单查询',
        component: resolve => require(['@/components/index/index'], resolve),
        children: [
            {
                name: '团队交易保订单',
                path: '/teamDealFrom',
                component: resolve => require(['@/pages/teamOrder/dealForm'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '团队提放保订单',
                path: '/teamInsureOrder',
                component: resolve => require(['@/pages/teamOrder/insureOrder'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '团队商转公订单',
                path: '/teamBusinessOrder',
                component: resolve => require(['@/pages/teamOrder/businessOrder'], resolve),
                meta:{
                    requireAuth: true
                },
            },
        ]
    },

    //草稿箱
    {
        path: '/',
        name: '草稿箱',
        component: resolve => require(['@/components/index/index'], resolve),
        children: [
            {
                name: '交易保',
                path: '/drawDrafts',
                component: resolve => require(['@/pages/drafts/drawDrafts'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '提放保',
                path: '/insureDrafts',
                component: resolve => require(['@/pages/drafts/insureDrafts'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '商转公',
                path: '/businessDrafts',
                component: resolve => require(['@/pages/drafts/businessDrafts'], resolve),
                meta:{
                    requireAuth: true
                },
            },
        ]
    },

    //我的申请
    {
        path: '/',
        name: '我的申请',
        component: resolve => require(['@/components/index/index'], resolve),
        children: [
            {
                name: '减免/退费申请',
                path: '/refundApply',
                component: resolve => require(['@/pages/myApply/refundApply'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '银行卡验证申请',
                path: '/bankApply',
                component: resolve => require(['@/pages/myApply/bankApply'], resolve),
                meta:{
                    requireAuth: true
                },
            },
        ]
    },

    //业务审批
    {
        path: '/',
        name: '业务审批',
        component: resolve => require(['@/components/index/index'], resolve),
        children: [
            {
                name: '业务交易保审批',
                path: '/drawApproval',
                component: resolve => require(['@/pages/businessApproval/drawApproval'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '业务提放保审批',
                path: '/insureApproval',
                component: resolve => require(['@/pages/businessApproval/insureApproval'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '业务商转公审批',
                path: '/businessApproval',
                component: resolve => require(['@/pages/businessApproval/businessApproval'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '退单审批',
                path: '/chargebackApproval',
                component: resolve => require(['@/pages/businessApproval/chargebackApproval'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '监控资料审批',
                path: '/monitorApproval',
                component: resolve => require(['@/pages/businessApproval/monitorApproval'], resolve),
                meta:{
                    requireAuth: true
                },
            },
        ]
    },

    //财务管理
    {
        path: '/',
        name: '财务审批',
        component: resolve => require(['@/components/index/index'], resolve),
        children: [
            {
                name: '核行审查审批',
                path: '/refundApproval',
                component: resolve => require(['@/pages/financeManage/refundApproval'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '核行审查详情',
                path: '/refundApprovalDetail',
                component: resolve => require(['@/pages/financeManage/refundApprovalDetail'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '银行卡验证审核',
                path: '/bankVerify',
                component: resolve => require(['@/pages/financeManage/bankVerify'], resolve),
                meta:{
                    requireAuth: true,
                    keepAlive: false,
                },
            },
            {
                name: '银行卡验证详情',
                path: '/bankDetail',
                component: resolve => require(['@/pages/financeManage/bankDetail'], resolve),
                meta:{
                    requireAuth: true,
                    keepAlive: false,
                },
            },
        ]
    },

    //资料管理
    {
        path: '/',
        name: '资料管理',
        component: resolve => require(['@/components/index/index'], resolve),
        children: [
            {
                name: '交易保资料',
                path: '/dealData',
                component: resolve => require(['@/pages/dataManage/dealData'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '提放保资料',
                path: '/insureData',
                component: resolve => require(['@/pages/dataManage/insureData'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '商转公资料',
                path: '/businessData',
                component: resolve => require(['@/pages/dataManage/businessData'], resolve),
                meta:{
                    requireAuth: true
                },
            },
        ]
    },

    //合同管理
    {
        path: '/',
        name: '合同管理',
        component: resolve => require(['@/components/index/index'], resolve),
        children: [
            {
                name: '交易保合同',
                path: '/dealContract',
                component: resolve => require(['@/pages/contractManage/dealContract'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '提放保合同',
                path: '/insureContract',
                component: resolve => require(['@/pages/contractManage/insureContract'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '商转公合同',
                path: '/businessContract',
                component: resolve => require(['@/pages/contractManage/businessContract'], resolve),
                meta:{
                    requireAuth: true
                },
            },
        ]
    },

    //系统设置
    {
        path: '/',
        name: '系统设置',
        component: resolve => require(['@/components/index/index'], resolve),
        children: [
            {
                name: '机构设置',
                path: '/institutionSetting',
                component: resolve => require(['@/pages/SystemManage/institutionSetting'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '角色设置',
                path: '/roleSetting',
                component: resolve => require(['@/pages/SystemManage/roleSetting'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '菜单管理',
                path: '/menuManage',
                component: resolve => require(['@/pages/SystemManage/menuManage'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '用户管理',
                path: '/userManage',
                component: resolve => require(['@/pages/SystemManage/userManage'], resolve),
                meta:{
                    requireAuth: true
                },
            },
            {
                name: '审批流程设置',
                path: '/approvalSetting',
                component: resolve => require(['@/pages/SystemManage/approvalSetting'], resolve),
                meta:{
                    requireAuth: true
                },
            },
        ]
    },

    //操作记录
    {
        path: '/',
        name: '操作记录',
        component: resolve => require(['@/components/index/index'], resolve),
        children: [
            {
                name: '修改记录',
                path: '/EditRecord',
                component: resolve => require(['@/pages/Records/EditRecord'], resolve),
                meta:{
                    requireAuth: true
                },
            },
        ]
    },
]

const router = new Router({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    let token = localStorage.getItem('token');

    // // 判断该路由是否需要登录权限
    // if (to.matched.some(record => record.meta.requireAuth)) {
    //     if (token) {
    //         // 判断当前的token是否存在
    //         next();
    //     } else {
    //         Message({
    //             type: 'error',
    //             message: '获取用户信息失败，请重新登录！'
    //         })
    //         next({
    //             path: '/login',
    //             query: { redirect: to.fullPath }
    //             // 将跳转的路由path作为参数，登录成功后跳转到该路由
    //         })
    //     }
    // } else {
        next();
    // }

    //跳转登录页中断所有请求
    if (to.path == '/login' && Vue.$httpReqList.length > 0) {
        Vue.$httpReqList.forEach(item => {
            //给个标志，中断请求
            item('interrupt');
        });
    }

    if (to.matched.length === 0) {
        // 如果未匹配到路由
        next('/404')
    } else {
        // 如果匹配到正确跳转
        next()
    }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js